<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.product_name" placeholder="请输入课程名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.course_name" placeholder="请输入详情名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="courseName" label="详情名称"></el-table-column>
            <el-table-column prop="coursePrize" label="详情价格"></el-table-column>
            <el-table-column prop="courseSort" label="序号"></el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.courseDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="courseDesc" label="详情描述"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <el-upload :action="importUrl" :headers="{ 'auth-admin': adminToken }" style="display: inline-block; margin-right: 10px;"
                        accept=".xlsx,.xls" :before-upload="beforeUpload" :on-success="onSuccess" :on-error="onError" :data="{ courseId: scope.row.courseId}" :show-file-list="false">
                        <el-button type="text" size="small" :loading="importLoading">导入题目</el-button>
                    </el-upload>
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="选择课程">
                        <el-select v-model="handleInfo.productId" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in products" :key="item.productId" :label="item.productName"
                                :value="item.productId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="课程名称">
                        <el-input v-model="handleInfo.courseName"></el-input>
                    </el-form-item>
                    <el-form-item label="课程价格">
                        <el-input v-model="handleInfo.coursePrize"></el-input>
                    </el-form-item>
                    <el-form-item label="课程序号">
                        <el-input v-model="handleInfo.courseSort"></el-input>
                    </el-form-item>
                    <el-form-item label="课程描述">
                        <el-input v-model="handleInfo.courseDesc"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    props: {
        header: {
            type: Boolean,
            default: true
        },
        productId: {
            type: String,
            default: ""
        }
    },
    data: function () {
        return {
            importUrl: process.env.VUE_APP_BASE_API + "/question/import",
            importLoading: false,
            adminToken: "",
            products: [],
        }
    },
    methods: {
        beforeUpload() {
            this.importLoading = true;
            return true;
        },
        // 请求成功回调
        onSuccess(res) {
            this.$message.success("导入成功");
            this.initialData();
            this.importLoading = false;
        },
        // 请求失败回调
        onError(err) {
            this.$message.error("导入失败");
            this.importLoading = false;
        },
    },
    watch: {
        productId: function (newVal) {
            this.filterParams.product_id = newVal;
            this.initialData();
        }
    },
    created: async function () {
        this.adminToken = localStorage.getItem("AUTH-ADMIN");
        this.tag = "COURSE";
        if (this.productId) {
            this.filterParams.product_id = this.productId;
        }
        this.products = await doGet(API.ALL.PRODUCT);
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>